export default __webpack_public_path__ + "static/media/fasad12.cbcc7409.jpeg";